import React from 'react';
import TabelaProdutos from "../../components/TabelaProdutos";
import TabelaEscaloes from "./TabelaEscaloes";
import {useVirbac} from "../../VirbacProvider";

const Produtos = () => {
   const virbac = useVirbac();

   return <div className={"Produtos"}>
      <TabelaProdutos
          colunas={["imagem", "codigo", "nome", "pontos", "escalao", "accoes"]}
          exportUrl={`${process.env.REACT_APP_API_URL}/produto/listar?exportar_excel`}
          showNewButton={virbac.utilizador.Tipo === "admin"}
          newButtonName={"Novo produto"}
      />

      <div className={"row"}>
         <div className={"col-md-5"}>
            <TabelaEscaloes/>
         </div>
      </div>
   </div>
};

export default Produtos;